<template>
  <div>
    <div class="toolbar">
      <el-form inline class="filters">
        <el-input v-model.trim="filters.keyword" class="task-keyword" placeholder="任务编号" clearable @keyup.enter.native="search"/>
        <el-select v-model="filters.status" class="task-status" clearable placeholder="全部状态">
          <el-option v-for="item in statuses" :key="item.value" :label="item.label" :value="item.value"/>
        </el-select>
        <el-date-picker v-model="filters.dates" class="task-dates" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable/>
        <el-button type="primary" :loading="loading" @click="search">{{loading?'查询中':'查询'}}</el-button>
        <el-button :disabled="loading" @click="reset">重置</el-button>
      </el-form>
      <el-button :loading="loading" @click="load">刷新</el-button>
    </div>

    <el-table :data="items" v-loading="loading" empty-text="暂无符合条件的任务">
      <el-table-column prop="id" label="任务编号" min-width="280" show-overflow-tooltip/>
      <el-table-column label="创建时间" width="165"><template slot-scope="s">{{ formatTime(s.row.created_at) }}</template></el-table-column>
      <el-table-column label="完成时间" width="165"><template slot-scope="s">{{ s.row.status === 'running' ? '进行中' : formatTime(s.row.finished_at) }}</template></el-table-column>
      <el-table-column label="状态" width="110"><template slot-scope="s"><el-tag :type="statusType(s.row.status)">{{ statusLabel(s.row.status) }}</el-tag></template></el-table-column>
      <el-table-column label="阶段" width="100"><template slot-scope="s">{{ stageLabel(s.row.stage) }}</template></el-table-column>
      <el-table-column label="结果摘要" min-width="200"><template slot-scope="s">{{ s.row.stop_reason || '-' }}</template></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="s">
          <el-button type="text" :loading="detailLoading && detailRunId === s.row.id" :disabled="detailLoading" @click="openDetail(s.row)">{{ detailLoading && detailRunId === s.row.id ? '加载中' : '查看详情' }}</el-button>
          <el-button v-if="s.row.status === 'running'" type="text" class="danger" :loading="stoppingId===s.row.id" :disabled="!!stoppingId" @click="stop(s.row)">{{stoppingId===s.row.id?'停止中':'停止'}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="total" class="pagination"><el-pagination background layout="total, prev, pager, next, jumper" :disabled="loading" :current-page="page" :page-size="pageSize" :total="total" @current-change="changePage"/></div>

    <el-drawer title="任务详情" :visible="detailVisible" size="72%" @close="detailVisible = false">
      <div class="detail" v-loading="detailLoading">
        <el-descriptions v-if="detail" :column="2" border>
          <el-descriptions-item label="任务编号" :span="2">{{ detail.run.id }}</el-descriptions-item>
          <el-descriptions-item label="状态">{{ statusLabel(detail.run.status) }}</el-descriptions-item>
          <el-descriptions-item label="阶段">{{ stageLabel(detail.run.stage) }}</el-descriptions-item>
          <el-descriptions-item label="失败原因" :span="2">{{ detail.run.stop_reason || '-' }}</el-descriptions-item>
        </el-descriptions>
        <h4>平台执行情况</h4>
        <el-table :data="detail ? detail.platform_runs || [] : []" empty-text="暂无平台执行明细">
          <el-table-column prop="platform" label="平台"/>
          <el-table-column prop="status" label="状态"><template slot-scope="s">{{ statusLabel(s.row.status) }}</template></el-table-column>
          <el-table-column prop="stage" label="阶段"><template slot-scope="s">{{ stageLabel(s.row.stage) }}</template></el-table-column>
          <el-table-column prop="failure_code" label="错误类型" min-width="180">
            <template slot-scope="s"><el-tag v-if="s.row.failure_code" type="danger" size="mini">{{ failureLabel(s.row.failure_code) }}</el-tag><span v-else>-</span></template>
          </el-table-column>
          <el-table-column prop="error_summary" label="失败原因" min-width="320"><template slot-scope="s">{{ s.row.error_summary || '-' }}</template></el-table-column>
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { yuqingApi } from '@/api/yuqing'

function today () {
  const date = new Date()
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export default {
  data () {
    return {
      items: [], total: 0, page: 1, pageSize: 20, loading: false, stoppingId: '', detail: null, detailLoading: false, detailRunId: '', detailVisible: false,
      filters: { keyword: '', status: '', dates: [today(), today()] },
      statuses: [{ value: 'running', label: '运行中' }, { value: 'completed', label: '已完成' }, { value: 'partial_failed', label: '部分失败' }, { value: 'failed', label: '失败' }, { value: 'stopped', label: '已停止' }]
    }
  },
  mounted () { this.load() },
  methods: {
    async load () {
      this.loading = true
      try {
        const params = { currentPage: this.page, pageSize: this.pageSize }
        if (this.filters.keyword) params.keyword = this.filters.keyword
        if (this.filters.status) params.status = this.filters.status
        if (this.filters.dates && this.filters.dates.length === 2) { params.startAt = this.filters.dates[0]; params.endAt = this.filters.dates[1] }
        const result = await yuqingApi.get('runs', params)
        this.items = result.items || []
        this.total = result.total || 0
      } catch (error) { this.$message.error(error.message) } finally { this.loading = false }
    },
    search () { if (this.loading) return; this.page = 1; return this.load() },
    reset () { if (this.loading) return; this.filters = { keyword: '', status: '', dates: [today(), today()] }; return this.search() },
    changePage (page) { this.page = page; this.load() },
    async openDetail (row) {
      if (this.detailLoading) return
      this.detailVisible = true
      this.detail = null
      this.detailLoading = true
      this.detailRunId = row.id
      try { this.detail = await yuqingApi.get(`runs/${encodeURIComponent(row.id)}`) } catch (error) { this.$message.error(error.message) } finally { this.detailLoading = false; this.detailRunId = '' }
    },
    async stop (row) {
      if (this.stoppingId) return
      try {
        await this.$confirm('停止后当前任务不会继续采集。确定停止吗？', '停止任务', { type: 'warning' })
        this.stoppingId = row.id
        await yuqingApi.post(`runs/${encodeURIComponent(row.id)}/stop`, {})
        this.$message.success('任务已停止')
        await this.load()
      } catch (error) { if (error !== 'cancel' && error !== 'close') this.$message.error(error.message || '停止任务失败') } finally { this.stoppingId = '' }
    },
    statusLabel (status) { return ({ running: '运行中', completed: '已完成', partial_failed: '部分失败', failed: '失败', stopped: '已停止', budget_exhausted: '额度用完', not_executed: '未执行' })[status] || status || '-' },
    statusType (status) { return ({ running: 'warning', completed: 'success', partial_failed: 'warning', failed: 'danger', stopped: 'info' })[status] || 'info' },
    stageLabel (stage) { return ({ search: '搜索', report: '生成报告', stopped: '已停止', budget: '额度检查', quota: '额度保护' })[stage] || stage || '-' },
    failureLabel (code) {
      return ({
        DAILY_LIMIT_EXCEEDED: '今日额度已用完',
        QUOTA_REDIS_UNAVAILABLE: 'Redis额度服务不可用',
        QUOTA_REDIS_INVALID_RESULT: 'Redis额度结果异常',
        QUOTA_INITIALIZATION_FAILED: '当日额度初始化失败',
        REQUEST_LOG_WRITE_FAILED: '请求日志预占失败'
      })[code] || code
    },
    formatTime (value) { return value ? String(value).replace('T', ' ').slice(0, 16) : '-' }
  }
}
</script>

<style scoped>
.toolbar { display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px; }
.filters { margin-bottom: 0; }
.task-keyword { width: 260px; }
.task-status { width: 130px; }
.task-dates { width: 260px; }
.pagination { display: flex; justify-content: flex-end; margin-top: 16px; }
.detail { padding: 0 20px 20px; }
.danger { color: #f56c6c; }
</style>
